import React, { useEffect, useState } from 'react';
import { FcDonate } from 'react-icons/fc';
import DialogComponent from '../dialog/dialog.component';
import VerifyBadge from '../verify-badge/verify-badge.component';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import { donatePost, fetchBalance } from '../../api';
import toast from 'react-hot-toast';
import { InputNumber } from 'antd';
import DialogPayment from '../dialog-payment';
import { InputWarning } from '../inputwarning/input-warning.component';
import PetPet from '../petpet/petpet.component';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import VoiceRecorder, { VoiceRecorderValue } from '../donate-voice/voice-recorder';
import { submitWithVoice } from '../donate-voice/submit-with-voice';
import { uploadVoiceMessage } from '../../api/payment/donate-voice.api';

const PostDonate = ({ post }: any) => {
  const { isOn } = useFeatureFlags();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [petpet, setPetpet] = useState<{ src?: string; label: string } | null>(null);
  const profileUser = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const [donationAmount, setDonationAmount] = useState<any>();
  const [submitting, setSubmitting] = useState(false); // QA S-14: chống donate 2 lần
  const [content, setContent] = useState('');
  // Ẩn danh: chỉ che ở các bề mặt CÔNG KHAI (lịch sử donate, overlay livestream).
  const [isAnonymous, setIsAnonymous] = useState(false);
  const [balance, setBalance] = useState(0);
  const [voiceClip, setVoiceClip] = useState<VoiceRecorderValue | null>(null);
  const [isRecordingVoice, setIsRecordingVoice] = useState(false);
  const handleContentChange = (e) => {
    setContent(e.target.value);
  };
  // Function to toggle dialog visibility
  const toggleDialog = () => {
    setIsDialogOpen(!isDialogOpen);
  };
  // State for the money input
  // Function to handle changes to the input field

  const handleSubmit = () => {
    if (!donationAmount) {
      toast.error('Vui lòng nhập số tiền bạn muốn donate.');
      return;
    }
    if (submitting) return; // QA S-14: chặn bấm 2 lần -> trừ Ca gấp đôi
    setSubmitting(true);

    const donate = (voiceClipId?: string) =>
      donatePost({
        postId: post?.id,
        toUserId: post?.userId,
        message: content,
        amount: donationAmount,
        isAnonymous,
        ...(voiceClipId ? { voiceClipId } : {}),
      })
        .then((res) => {
          const total = `${donationAmount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          toast.success(
            `Bạn đã donate ${total} ca thành công cho bài viết của ${post?.userFullName}`,
            {
              duration: 4000,
              position: 'top-center',
            }
          );
          // Hiệu ứng Pet Pet: vỗ đầu avatar tác giả để "cảm ơn".
          setPetpet({
            src: post?.avatar,
            label: `Đã vỗ đầu ${post?.userFullName || ''} · +${total} ca 💛`,
          });
          setDonationAmount(null);
          setIsAnonymous(false);
          setVoiceClip(null);
          toggleDialog();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || 'Donate thất bại, vui lòng thử lại.');
        })
        .finally(() => setSubmitting(false));

    // Có ghi âm ⇒ tải lên media-service trước để lấy voiceClipId, lỗi thì dừng, không donate.
    submitWithVoice(voiceClip, donate, uploadVoiceMessage).catch(() => setSubmitting(false));
  };

  function formatVND(value) {
    const amount = Number(value);
    if (isNaN(amount)) return '0 đồng'; // Return "0 VND" if the value is not a number

    // Format the number with commas and add " VND" suffix
    return `${amount
      .toFixed(0)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} đồng`;
  }
  useEffect(() => {
    // Rà soát 28/10: chỉ Ca NẠP mới donate được, nên hiện số Ca nạp thay vì tổng số dư.
    fetchBalance().then((res) => {
      setBalance(res.topUpBalance ?? res.balance);
    });
  }, []);

  if (!isOn('feature.donate')) return null; // admin tắt donate

  return (
    <>
      <button type="button" className="ml-auto" onClick={toggleDialog}>
        <svg
          width="85"
          height="32"
          viewBox="0 0 85 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="85" height="32" rx="16" className="fill-[#EAEFFA] dark:fill-slate-700" />
          <path
            d="M9.90039 15.2L11.6004 18.5L14.7671 17.2L16.2337 12.9667L11.3004 13.2333L9.90039 15.2Z"
            fill="#E69329"
          />
          <path
            d="M11.0004 22.6C12.4363 22.6 13.6004 21.436 13.6004 20C13.6004 18.5641 12.4363 17.4 11.0004 17.4C9.56445 17.4 8.40039 18.5641 8.40039 20C8.40039 21.436 9.56445 22.6 11.0004 22.6Z"
            fill="#546E7A"
          />
          <path
            d="M11 17C9.33333 17 8 18.3333 8 20C8 21.6667 9.33333 23 11 23C12.6667 23 14 21.6667 14 20C14 18.3333 12.6667 17 11 17ZM11 22.3333C9.7 22.3333 8.66667 21.3 8.66667 20C8.66667 18.7 9.7 17.6667 11 17.6667C12.3 17.6667 13.3333 18.7 13.3333 20C13.3333 21.3 12.3 22.3333 11 22.3333Z"
            fill="#90A4AE"
          />
          <path d="M10.666 19H11.3327V21.6667H10.666V19Z" fill="#90A4AE" />
          <path
            d="M10.301 20C10.6343 20.6334 11.3676 20.9 12.001 20.5667L17.501 17.7334C17.8343 17.5667 18.0676 17.3334 18.2343 17.1C18.801 16.0334 20.101 13.5334 20.9676 11.3667L14.901 14.2667L13.301 16.6667L11.0343 17.8667C10.1676 18.3 9.90098 19.2667 10.301 20Z"
            fill="#FFB74D"
          />
          <path
            d="M16.0669 9L10.5669 11.1C10.3336 11.1667 10.0669 11.4333 9.83358 11.6667L7.96691 14.1667C7.63358 14.6667 7.56691 15.3 7.80025 15.8667C7.93358 16.2 8.36691 17 8.83358 17.9C9.36691 17.3333 10.1336 17 11.0002 17C11.1336 17 11.3002 17 11.4336 17.0333L10.7336 15.6333L12.2669 14.2667H14.9336C14.9336 14.2667 20.1002 13.5333 21.0002 11.3667L16.0669 9Z"
            fill="#FFB74D"
          />
          <path
            d="M12.0665 20C11.6332 20.2 11.1332 20 10.9665 19.5667C10.7665 19.1333 10.9665 18.6333 11.3998 18.4667C11.7998 18.2667 12.4665 19.8 12.0665 20Z"
            fill="#FFCDD2"
          />
          <path
            d="M34.4545 21.5H31.0043V11.3182H34.5241C35.535 11.3182 36.4034 11.522 37.1293 11.9297C37.8584 12.334 38.4186 12.9157 38.8097 13.6747C39.2008 14.4337 39.3963 15.3419 39.3963 16.3991C39.3963 17.4598 39.1991 18.3712 38.8047 19.1335C38.4136 19.8958 37.8485 20.4808 37.1094 20.8885C36.3736 21.2962 35.4886 21.5 34.4545 21.5ZM32.8487 19.9041H34.3651C35.0743 19.9041 35.666 19.7749 36.1399 19.5163C36.6139 19.2545 36.9702 18.8651 37.2088 18.348C37.4474 17.8277 37.5668 17.178 37.5668 16.3991C37.5668 15.6203 37.4474 14.974 37.2088 14.4602C36.9702 13.9432 36.6172 13.5571 36.1499 13.3018C35.6858 13.0433 35.1091 12.9141 34.4197 12.9141H32.8487V19.9041ZM44.4002 21.6491C43.6545 21.6491 43.0082 21.4851 42.4613 21.157C41.9144 20.8288 41.4902 20.3698 41.1886 19.7798C40.8903 19.1899 40.7411 18.5005 40.7411 17.7116C40.7411 16.9228 40.8903 16.2318 41.1886 15.6385C41.4902 15.0452 41.9144 14.5845 42.4613 14.2564C43.0082 13.9283 43.6545 13.7642 44.4002 13.7642C45.146 13.7642 45.7923 13.9283 46.3391 14.2564C46.886 14.5845 47.3086 15.0452 47.6069 15.6385C47.9085 16.2318 48.0593 16.9228 48.0593 17.7116C48.0593 18.5005 47.9085 19.1899 47.6069 19.7798C47.3086 20.3698 46.886 20.8288 46.3391 21.157C45.7923 21.4851 45.146 21.6491 44.4002 21.6491ZM44.4102 20.2074C44.8145 20.2074 45.1526 20.0964 45.4244 19.8743C45.6961 19.6489 45.8983 19.3473 46.0309 18.9695C46.1668 18.5916 46.2347 18.1707 46.2347 17.7067C46.2347 17.2393 46.1668 16.8168 46.0309 16.4389C45.8983 16.0578 45.6961 15.7545 45.4244 15.5291C45.1526 15.3037 44.8145 15.1911 44.4102 15.1911C43.9959 15.1911 43.6512 15.3037 43.3761 15.5291C43.1043 15.7545 42.9004 16.0578 42.7646 16.4389C42.632 16.8168 42.5657 17.2393 42.5657 17.7067C42.5657 18.1707 42.632 18.5916 42.7646 18.9695C42.9004 19.3473 43.1043 19.6489 43.3761 19.8743C43.6512 20.0964 43.9959 20.2074 44.4102 20.2074ZM51.3865 17.0256V21.5H49.5868V13.8636H51.307V15.1612H51.3965C51.5721 14.7337 51.8522 14.3939 52.2367 14.142C52.6245 13.8902 53.1034 13.7642 53.6735 13.7642C54.2005 13.7642 54.6595 13.8769 55.0506 14.1023C55.445 14.3277 55.7499 14.6541 55.9654 15.0817C56.1841 15.5092 56.2918 16.0279 56.2885 16.6378V21.5H54.4888V16.9162C54.4888 16.4058 54.3562 16.0064 54.0911 15.718C53.8292 15.4297 53.4663 15.2855 53.0023 15.2855C52.6874 15.2855 52.4074 15.3551 52.1621 15.4943C51.9202 15.6302 51.7296 15.8274 51.5904 16.0859C51.4545 16.3445 51.3865 16.6577 51.3865 17.0256ZM60.3155 21.6541C59.8316 21.6541 59.3958 21.5679 59.008 21.3956C58.6235 21.2199 58.3186 20.9614 58.0932 20.62C57.8712 20.2786 57.7601 19.8577 57.7601 19.3572C57.7601 18.9264 57.8397 18.5701 57.9988 18.2884C58.1578 18.0066 58.3749 17.7812 58.65 17.6122C58.9251 17.4432 59.235 17.3156 59.5797 17.2294C59.9277 17.1399 60.2873 17.0753 60.6586 17.0355C61.106 16.9891 61.4689 16.9477 61.7473 16.9112C62.0257 16.8714 62.2279 16.8118 62.3539 16.7322C62.4831 16.6494 62.5478 16.5218 62.5478 16.3494V16.3196C62.5478 15.9451 62.4367 15.6551 62.2147 15.4496C61.9926 15.2441 61.6728 15.1413 61.2551 15.1413C60.8143 15.1413 60.4647 15.2375 60.2061 15.4297C59.9509 15.6219 59.7786 15.849 59.6891 16.1108L58.0087 15.8722C58.1413 15.4081 58.36 15.0204 58.665 14.7088C58.9699 14.3939 59.3427 14.1586 59.7836 14.0028C60.2244 13.8438 60.7116 13.7642 61.2452 13.7642C61.6131 13.7642 61.9793 13.8073 62.3439 13.8935C62.7085 13.9796 63.0416 14.1222 63.3432 14.321C63.6448 14.5166 63.8868 14.7834 64.0691 15.1214C64.2547 15.4595 64.3475 15.8821 64.3475 16.3892V21.5H62.6174V20.451H62.5577C62.4483 20.6631 62.2942 20.862 62.0953 21.0476C61.8998 21.2299 61.6529 21.3774 61.3546 21.4901C61.0596 21.5994 60.7132 21.6541 60.3155 21.6541ZM60.7828 20.3317C61.1441 20.3317 61.4573 20.2604 61.7225 20.1179C61.9876 19.9721 62.1915 19.7798 62.334 19.5412C62.4798 19.3026 62.5527 19.0424 62.5527 18.7607V17.8608C62.4964 17.9072 62.4003 17.9503 62.2644 17.9901C62.1318 18.0298 61.9827 18.0646 61.8169 18.0945C61.6512 18.1243 61.4872 18.1508 61.3248 18.174C61.1623 18.1972 61.0215 18.2171 60.9022 18.2337C60.6337 18.2701 60.3934 18.3298 60.1813 18.4126C59.9692 18.4955 59.8018 18.6115 59.6792 18.7607C59.5565 18.9065 59.4952 19.0954 59.4952 19.3274C59.4952 19.6589 59.6162 19.9091 59.8581 20.0781C60.1001 20.2472 60.4083 20.3317 60.7828 20.3317ZM69.9703 13.8636V15.2557H65.5804V13.8636H69.9703ZM66.6642 12.0341H68.464V19.2031C68.464 19.4451 68.5004 19.6307 68.5733 19.7599C68.6496 19.8859 68.749 19.9721 68.8716 20.0185C68.9943 20.0649 69.1301 20.0881 69.2793 20.0881C69.392 20.0881 69.4947 20.0798 69.5875 20.0632C69.6837 20.0466 69.7566 20.0317 69.8063 20.0185L70.1096 21.4254C70.0134 21.4586 69.8759 21.495 69.6969 21.5348C69.5212 21.5746 69.3058 21.5978 69.0506 21.6044C68.5998 21.6177 68.1938 21.5497 67.8326 21.4006C67.4713 21.2481 67.1846 21.0128 66.9725 20.6946C66.7637 20.3764 66.6609 19.9787 66.6642 19.5014V12.0341ZM74.7741 21.6491C74.0085 21.6491 73.3473 21.4901 72.7905 21.1719C72.237 20.8504 71.8111 20.3963 71.5128 19.8097C71.2145 19.2197 71.0653 18.5253 71.0653 17.7266C71.0653 16.9411 71.2145 16.2517 71.5128 15.6584C71.8144 15.0618 72.2353 14.5978 72.7756 14.2663C73.3158 13.9316 73.9505 13.7642 74.6797 13.7642C75.1503 13.7642 75.5945 13.8404 76.0121 13.9929C76.433 14.142 76.8042 14.3741 77.1257 14.6889C77.4505 15.0038 77.7057 15.4048 77.8913 15.892C78.0769 16.3759 78.1697 16.9527 78.1697 17.6222V18.174H71.9105V16.9609H76.4446C76.4413 16.6162 76.3667 16.3097 76.2209 16.0412C76.075 15.7694 75.8712 15.5556 75.6094 15.3999C75.3509 15.2441 75.0492 15.1662 74.7045 15.1662C74.3366 15.1662 74.0135 15.2557 73.7351 15.4347C73.4567 15.6103 73.2396 15.8423 73.0838 16.1307C72.9313 16.4157 72.8535 16.7289 72.8501 17.0703V18.1293C72.8501 18.5734 72.9313 18.9545 73.0938 19.2727C73.2562 19.5876 73.4832 19.8295 73.7749 19.9986C74.0665 20.1643 74.4079 20.2472 74.799 20.2472C75.0608 20.2472 75.2978 20.2107 75.5099 20.1378C75.7221 20.0616 75.906 19.9505 76.0618 19.8047C76.2176 19.6589 76.3352 19.4782 76.4148 19.2628L78.0952 19.4517C77.9891 19.8958 77.7869 20.2836 77.4886 20.6151C77.1937 20.9432 76.8158 21.1984 76.3551 21.3807C75.8944 21.5597 75.3674 21.6491 74.7741 21.6491Z"
            fill="#657384"
          />
        </svg>
      </button>
      <DialogComponent
        onClose={() => setIsDialogOpen(false)}
        visible={isDialogOpen}
        placement="CENTER"
        title="Donate"
        size="full"
        customSize="w-full max-w-[976px]"
      >
        <div className="flex flex-col  ">
          <div className="w-full h-12 flex justify-between px-5 items-center bg-[#ebecf2]">
            <span className="text-sm text-[#111827]  font-semibold">
              Ca nạp dùng để donate <span className="font-normal text-[#62677D]">(tối thiểu 10 Ca mỗi lần)</span>
            </span>
            <div className="flex items-center gap-1">
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.5 12L12.5 4"
                  stroke="#26B35E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 4H12.5V10.5"
                  stroke="#26B35E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span className="text-sm font-medium uppercase text-[#26B35E]">
                {Number(balance).toLocaleString('vi-VN')} ca
              </span>
            </div>
          </div>
          <div className="flex gap-3 flex-col p-6">
            <p className="text-base font-medium text-[#62677D] leading-5">
              Bạn đang donate tới tài khoản
            </p>
            <div className="flex flex-col gap-4">
              <div className="flex px-3 py-2 gap-2 border-b-[#E5E7EB] dark:border-b-slate-700 border-b">
                <div className="flex-shrink-0">
                  <img
                    className="h-10 w-10 rounded-full"
                    src={
                      post?.avatar ||
                      '/default-avatar.svg'
                    }
                    alt="avatar"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-[#111827]">
                    {post?.userFullName}
                  </span>
                  <p className="text-[#080809] font-medium text-xs truncate ">
                    {post?.description}
                  </p>
                  <p className="text-[#0071A6] font-medium text-xs ">
                    @{post?.username}
                  </p>
                </div>
                <VerifyBadge userType={post?.userType} />
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex items-center">
                  <label
                    htmlFor="donationAmount"
                    className=" font-medium text-sm text-gray-700 dark:text-gray-300"
                  >
                    Số ca
                  </label>
                  &nbsp;
                  <InputWarning />
                </div>
                <InputNumber
                  name="donationAmount"
                  id="donationAmount"
                  value={donationAmount}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  onChange={setDonationAmount}
                  className="block w-full rounded-lg pl-3 pr-10 py-2 text-base border-[#C8CCD8] sm:text-sm "
                  placeholder="Nhập số ca"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label
                  htmlFor="content"
                  className=" font-medium text-sm text-gray-700 dark:text-gray-300"
                >
                  Lời nhắn
                </label>
                <textarea
                  rows={3}
                  name="content"
                  id="content"
                  value={content}
                  onChange={handleContentChange}
                  className="mt-1 block w-full border  pl-3 pr-10 py-2 text-base border-[#C8CCD8] focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-lg"
                  placeholder="Nhập nội dung"
                />

                <VoiceRecorder
                  creatorId={post?.userId}
                  amount={Number(donationAmount) || 0}
                  onChange={setVoiceClip}
                  onRecordingChange={setIsRecordingVoice}
                />

                <label className="mt-3 flex items-start gap-2 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={isAnonymous}
                    onChange={(e) => setIsAnonymous(e.target.checked)}
                    className="mt-[3px] h-4 w-4 shrink-0 rounded border-[#C8CCD8] accent-blue-600"
                  />
                  <span className="text-sm text-gray-700 dark:text-gray-300">
                    Donate ẩn danh
                    <span className="block text-xs text-gray-500 dark:text-gray-400">
                      Ẩn tên bạn khỏi lịch sử donate công khai và thông báo trên livestream.
                      Người nhận vẫn thấy tên bạn trong thông báo riêng.
                    </span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="gap-4 flex justify-end p-6">
          <DialogPayment
            onConfirm={(value) => {
              console.log('🚀 ~ PostDonate ~ value:', value);
            }}
            onCancel={() => {
              console.log('🚀 ~ PostDonate ~ value:');
            }}
          />

          <button
            onClick={handleSubmit}
            disabled={submitting || isRecordingVoice}
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {submitting ? 'Đang gửi…' : 'Donate'}
          </button>
        </div>
      </DialogComponent>
      {petpet && (
        <PetPet src={petpet.src} label={petpet.label} onDone={() => setPetpet(null)} />
      )}
    </>
  );
};

export default PostDonate;
